import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC05BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import {
    resetDataFC_05, actualizarFC_05Estatus, actualizarFC_05Fecha,
    actualizarFileFC_05,
    agregarFileFC_05,

} from '../../../redux/DucksBeneficiario/FC_05Ducks';
import moment from 'moment'


const DocumentacionFC_05Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_05Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_05Solicitud.dataDocumentacion)
    const fechaHoy = moment().format('YYYY-MM-DD');
    const filesFC_05 = useSelector(store => store.FC_05Solicitud.files)
    let filesMap = useSelector(store => store.FC_05Solicitud.filesMap)
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)

    const [folio, setFolio] = React.useState('')

    const obtenerNumeroDeFiles = async () => {

        const countArchivos = await countFiles()
        const totalFilesGenerales = (files.filter(file => file.estatus === true)).length
        const contadorArchivo = totalFilesGenerales 

        if (countArchivos > contadorArchivo) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc05_solicitudusomarcaeimagen: data.idfc05_solicitudusomarcaeimagen }
            await dispatch(actualizarFC_05Fecha(solicitud))
            setFolio(data.folio)
            const idSolicitud = data.idfc05_solicitudusomarcaeimagen
            const estatusNuevo = 2
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_05 = 1
            const tabla = tablaFC_05
            await dispatch(actualizarFC_05Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_05())
            setEnvioCorrecto(true)
        }
    }

    const countFiles = async () => {
        let contador = 0
        if (data.embalaje ) contador += 1
        if (data.facturas ) contador += 1
        if (data.folletostripticos ) contador += 1
        if (data.paginaweb ) contador += 1
        if (data.espectaculares ) contador += 1
        if (data.rotuladoparedes ) contador += 1
        if (data.otrosdocumentos ) contador += 1
        return contador
    }

    React.useEffect(() => {
        if (filesFC_05) {
            let newFiles = []
            for (const file in filesFC_05) {
                const { ...newFile } = filesFC_05[file]
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }
    }, [data])

    /*React.useEffect(() => {
        return () => {
            dispatch(resetDataFC_05())
        }
    }, [])*/

    //FILES GENERALES
    const [files, setFile] = React.useState([])
    const handdleFile = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_05/agregarNuevoFC_05AnexosArchivos'
        }
        const result = await dispatch(agregarFileFC_05(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc_05archivos
            objectFile.estatus = true
            setFile(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrev = async (objectFile) => {

        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_05/actualizarFormatoFC05_AnexosArchivos'
                }
                const result = await dispatch(actualizarFileFC_05(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_05/agregarNuevoFC_05AnexosArchivos'
                    }
                    result = await dispatch(agregarFileFC_05(data))
                }
                if (result.payload.data?.data) {
                    setFile(newFiles)
                    return true
                } else {
                    const newFiles = files.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFile(newFiles)
                    return false
                }
            }
        }
    }

    const FilesGenerales = () => {
        return (
            <div>
                <Collapsible trigger="Documentación general" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        {data.embalaje && <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGEM'} tabla={"FC_05_anexos"}
                            filesMap={filesMap}
                            textLabel={`Embalaje: `} textoTooltip='Embalaje.'
                            idAnexoFK={data.idfc05_solicitudusomarcaeimagen} />}
                        {data.facturas && <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGFA'} tabla={"FC_05_anexos"}
                            filesMap={filesMap}
                            textLabel={`Facturas: `}
                            textoTooltip='Facturas.'
                            idAnexoFK={data.idfc05_solicitudusomarcaeimagen} />}
                        {data.folletostripticos && <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGFT'} tabla={"FC_05_anexos"}
                            filesMap={filesMap}
                            textLabel={`Folletos y/o tripticos: `}
                            textoTooltip='Folletos y/o tripticos.'
                            idAnexoFK={data.idfc05_solicitudusomarcaeimagen} />}
                        {data.paginaweb && <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGPW'} tabla={"FC_05_anexos"}
                            filesMap={filesMap}
                            textLabel={`Página web: `}
                            textoTooltip='Página web.'
                            idAnexoFK={data.idfc05_solicitudusomarcaeimagen} />}
                        {data.espectaculares && <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGES'} tabla={"FC_05_anexos"}
                            filesMap={filesMap}
                            textLabel={`Espectaculares: `}
                            textoTooltip='Espectaculares.'
                            idAnexoFK={data.idfc05_solicitudusomarcaeimagen} />}
                        {data.rotuladoparedes && <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGRP'} tabla={"FC_05_anexos"}
                            filesMap={filesMap}
                            textLabel={`Rotulado en paredes: `}
                            textoTooltip='Rotulado en paredes.'
                            idAnexoFK={data.idfc05_solicitudusomarcaeimagen} />}
                        {data.otrosdocumentos && <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGOD'} tabla={"FC_05_anexos"}
                            filesMap={filesMap}
                            textLabel={`Otros Documentos: `}
                            textoTooltip='Otros Documentos.'
                            idAnexoFK={data.idfc05_solicitudusomarcaeimagen} />}
                    </div>
                </Collapsible>
            </div>
        )
    }

    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                <div className='ms-5'>
                    {FilesGenerales()}
                </div>
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center ms-5">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envío</button>
                    </div>
                }

            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_05Component)
